import React, { useContext } from 'react';
import { AdminContext } from '../../context/admin-context';
import { TenantContext } from '../../context/tenant-context';
import { ProductFruits } from 'react-product-fruits';

export const ProductFruitsWrapper = () => {
  const { email, name } = useContext(AdminContext);
  const { tenant } = useContext(TenantContext);

  return tenant == 'seedot' ? (
    <ProductFruits
      workspaceCode="hnBxYjWfXQm2S1KQ"
      language="en"
      user={{ username: `${tenant}-${email}`, email, firstname: name }}
    />
  ) : (
    <></>
  );
};
